import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterCastOffVehiclesComponent } from './filter-cast-off-vehicles/filter-cast-off-vehicles.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FilterEvaluationVehiclesComponent } from './filter-evaluation-vehicles/filter-evaluation-vehicles.component';
import { EvaluationHistoryFilterComponent } from './evaluation-history-filter/evaluation-history-filter.component';
import { FilterDetailsComponent } from './filter-cast-off-vehicles/filter-details/filter-details.component';
import { FilterEvalLeadsComponent } from './filter-eval-leads/filter-eval-leads.component';
import { NgxDaterangepickerBootstrapDirective } from 'ngx-daterangepicker-bootstrap';
import { DaterangepickerMatInputDirective } from '@app/shared/directives/daterangepicker-mat-input.directive';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';

const components = [
  FilterCastOffVehiclesComponent,
  FilterEvaluationVehiclesComponent,
  EvaluationHistoryFilterComponent,
  FilterEvalLeadsComponent,
  FilterDetailsComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    CurrencyMaskModule,
    NgxDaterangepickerBootstrapDirective,
    DaterangepickerMatInputDirective,
    MatFormFieldModule,
    MatSliderModule,
    RouterModule,
    MatChipsModule
  ]
})
export class FiltersModule { }
